var _mask, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLaptopDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 57,
    viewBox: "0 0 92 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1042_1072",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.777 57.0001H4.68319C2.14236 57.0001 0.0898438 54.9474 0.0898438 52.4067H91.4681C91.4674 54.85 89.3173 57.0001 86.7765 57.0001H86.777Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.777 57.0001H4.68319C2.14236 57.0001 0.0898438 54.9474 0.0898438 52.4067H91.4681C91.4674 54.85 89.3173 57.0001 86.7765 57.0001H86.777Z",
    fill: "#0E0E0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0898438 52.4067V51.0734H-1.24349V52.4067H0.0898438ZM91.4681 52.4067L92.8014 52.4071L92.8018 51.0734H91.4681V52.4067ZM86.777 55.6668H4.68319V58.3334H86.777V55.6668ZM4.68319 55.6668C2.87878 55.6668 1.42318 54.211 1.42318 52.4067H-1.24349C-1.24349 55.6837 1.40595 58.3334 4.68319 58.3334V55.6668ZM0.0898438 53.7401H91.4681V51.0734H0.0898438V53.7401ZM90.1348 52.4064C90.1343 54.0956 88.599 55.6668 86.7765 55.6668V58.3334C90.0357 58.3334 92.8006 55.6044 92.8014 52.4071L90.1348 52.4064ZM86.7765 58.3334H86.777V55.6668H86.7765V58.3334Z",
    fill: "#0E0E0E",
    mask: "url(#path-1-inside-1_1042_1072)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3338 49.8657H7.12648C6.73586 49.8657 6.34455 49.5725 6.34455 49.0837L6.34387 4.71396C6.34387 2.66132 8.0052 1 10.0578 1H81.4013C83.4539 1 85.1152 2.66132 85.1152 4.71396V49.1815C85.1152 49.5721 84.7244 49.8657 84.3338 49.8657Z",
    stroke: "#0E0E0E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLaptopDark);
export default __webpack_public_path__ + "static/media/icon-laptop-dark.753fe85cfbacd85c7820fe9d5b4878a3.svg";
export { ForwardRef as ReactComponent };